module.exports = __webpack_public_path__ + "static/media/czerwony_normal.8b3ec8bf.png";